// extracted by mini-css-extract-plugin
module.exports = {"color_primary1":"#ff9a9e","color_primary2":"#f6416c","color_primary3":"#92a8d1","color_primary4":"#155ee5c2","frame":"Frame_frame__32xJl"};